import { useCallback, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { PdfTemplateWorkbench } from "../pdf";

export function DeveloperTestPage() {
  const [fileSource, setFileSource] = useState<File | null>(null);
  const [urlInput, setUrlInput] = useState("");
  const [urlSource, setUrlSource] = useState<string | null>(null);

  const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const nextFile = event.target.files?.[0] ?? null;
    setFileSource(nextFile);
  }, []);

  const handleUrlLoad = useCallback(() => {
    const trimmed = urlInput.trim();
    setUrlSource(trimmed || null);
  }, [urlInput]);

  return (
    <div className="space-y-8">
      <Card>
        <CardHeader>
          <CardTitle>PDF File Preview</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="pdf-file">Upload PDF</Label>
            <Input
              id="pdf-file"
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </div>
          {fileSource ? (
            <div className="h-[800px]">
              <PdfTemplateWorkbench source={fileSource} />
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">Select a PDF file to preview.</p>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>S3 URL Preview</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="pdf-url">Presigned URL</Label>
            <div className="flex gap-2">
              <Input
                id="pdf-url"
                placeholder="https://example.com/file.pdf"
                value={urlInput}
                onChange={(event) => setUrlInput(event.target.value)}
              />
              <Button onClick={handleUrlLoad}>Load</Button>
            </div>
          </div>
          {urlSource ? (
            <div className="h-[800px]">
              <PdfTemplateWorkbench source={urlSource} />
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">
              Enter a presigned URL to preview the PDF.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}


